import { AgTechTabPageProps, AgTechTabPageTemplate, AgTechTabbedPageTab } from "../../../Pages/Tabbed/AgTechTabPage"

const AgTechModernTabPage = (props: AgTechTabPageProps & { title: string, tabContent?: () => JSX.Element }) => {
    return (
        <AgTechTabPageTemplate
            {...props}
            panel={(tabs) => (
                <div className='wide row-based mb-5 flex'>
                    <div className="wide column-based mb-4 pb-2 flex">
                        <h1 className="text-2xl font-semibold ml-1">{props.title}</h1>
                        {props.header?.content && (
                            <div className="ml-auto my-auto flex">
                                {props.header.content()}
                            </div>
                        )}
                    </div>
                    <div className={`wide column-based h-[30px] flex ${props.header?.classes ?? ''}`}>
                        <div className="column-based wide mb-[-1px] flex">
                            {tabs.map(tab => (
                                <AgTechTabbedPageTab
                                    key={tab.text}
                                    {...tab}
                                    classes={{
                                        tab: 'px-4 py-[4px] centered border-b-[2px] border-b-transparent pb-1 font-semibold bg-transparent text-detail flex-initial mr-3 color-changing',
                                        active: 'text-primary border-b-[2px] !border-b-highlight'
                                    }}
                                />
                            ))}
                            {props.tabContent && (
                                <div className="tall ml-auto flex">
                                    {props.tabContent()}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        />
    )
}

export default AgTechModernTabPage;